import React from 'react';

export function Divider({ margin }) {
    return <div className={`${margin} w-full border-b-2 border-slate-100`}></div>
}
